var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col min-h-screen bg-primary"},[_c('header',[_c('app-bar')],1),_vm._v(" "),_c('main',{staticClass:"flex-grow"},[_c('transition',{attrs:{"name":"fade"}},[_c('nuxt')],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }